import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

import modules from './modules'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  getters,
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(val) {        // 持久化数据
      return {
        user: val.user,
        app: val.app,
        member: val.member,
        department: val.department,
        permission: val.permission
      }
    }
  })]
})
